import { ROUTER } from "./constants";
import moduleConstant from "./module-constant";
import { HistoryConfigurations } from "../models/history";
// const PrepareGeneral = () => import("../containers/property/prepare-general");
// const PersonModal = () => import("../containers/person/person-modal");
// const PersonDetail = () => import("../containers/person/person-detail");
// const DemandModal = () => import("../containers/demand/demand-modal");
// const DemandDetail = () => import("../containers/demand/demand-detail");
// const AgendaModal = () => import("../containers/agenda/agenda-modal");
// const AgendaDetail = () => import("../containers/agenda/agenda-detail");
// const TaskModal = () => import("../containers/task/task-modal");
// const TaskDetail = () => import("../containers/task/task-detail-view");
// const PropertyModal = () => import("../containers/property/property-modal");
// const PropertyDetail = () => import("../containers/property/property-detail-view");
// const ProjectModal = () => import("../containers/property/project-modal");
// const ProjectDetail = () => import("../containers/property/project-detail-view");
// const MatchingDemandsModal = () => import("../containers/property/property-detail-view/matching-demands-modal");
// const SendMessageViewModal = () => import("../containers/report/send-message/SendMessageModalComponent.vue");
// const PrintTemplateViewModal = () => import("../containers/report/print-template/PrintTemplateModalComponent.vue");
// const HistoryWrapper = () => import("../containers/history/wrapper");
// const PropertyPrepareClone = () => import("../containers/property/object-clone/property-clone");
// const ProjectPrepareClone = () => import("../containers/property/object-clone/project-clone");



export const ROUTER_HELPER = {
    TYPE: {
        PREPARE_PROPERTY: "prepare",
        CLONE_PROPERTY: "clone-property",
        PROPERTY: "property",
        PROJECT: "project",
        CLIENT: "client",
        TASK: "task",
        DEMAND: "demand",
        AGENDA: "agenda",
        SEND_MESSAGE: "send-message",
        MESSAGE_TO_RELATIONS: "message-to-relations",
        MESSAGE_TO_OWNER: "message-to-owner",
        MATCHING_DEMANDS: "matching-demand",
        MATCHING_PROPERTY: "matching-property",
        PRINT_TEMPLATE: "print-template",
        HISTORY: "history",
        GLOBAL: "global",
        CLONE_PROJECT: "clone-project"
    },
    ACTION: {
        VIEW: "view",
        EDIT: "edit",
        NEW: "new",
        PREPARE: "prepare"
    }
};

export const ROUTER_DATA_STORAGE = "RouterDynamic";

export const ROUTER_DYNAMIC_PATH = "dynamic";

export const ROUTER_OPTION = [
    // new prepare property or project
    {
        types: [ROUTER_HELPER.TYPE.PREPARE_PROPERTY],
        actions: [ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: PrepareGeneral
            },
            props: {
                default: (route) => ({ objectType: route.query.type })
            }
        }
    },

    // new, edit person
    {
        types: [ROUTER_HELPER.TYPE.CLIENT],
        actions: [ROUTER_HELPER.ACTION.NEW, ROUTER_HELPER.ACTION.EDIT],
        options: {
            meta: {
                moduleType: moduleConstant.Person,
                showSaveAndNew: false,
                showSaveAndClose: true,
                showSave: true,
                showView: false,
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: PersonModal
            }
        }
    },

    // view person
    {
        types: [ROUTER_HELPER.TYPE.CLIENT],
        actions: [ROUTER_HELPER.ACTION.VIEW],
        options: {
            meta: {
                moduleType: moduleConstant.Person,
                Mode: HistoryConfigurations.TYPE_ALL,
                showActionViewDemand: true,
                showActionEditDemand: true,
                showActionViewMatching: true,
                showActionViewProperty: true,
                showActionEditProperty: true,
                showNewDemand: true,
                showNewProperty: true,
                showSendMessage: true,
                showPrint: true,
                showEdit: true,
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
                viewHistory: true,
            },
            components: {
                // default: PersonDetail
            },
        }
    },

    // new, edit demand
    {
        types: [ROUTER_HELPER.TYPE.DEMAND],
        actions: [ROUTER_HELPER.ACTION.NEW, ROUTER_HELPER.ACTION.EDIT],
        options: {
            meta: {
                moduleType: moduleConstant.Demand,
                showSaveAndNew: false,
                showSaveAndClose: true,
                showSave: true,
                showView: false,
                showActionView: true,
                showActionNew: true,
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: DemandModal
            },
        }
    },

    // view demand
    {
        types: [ROUTER_HELPER.TYPE.DEMAND],
        actions: [ROUTER_HELPER.ACTION.VIEW],
        options: {
            meta: {
                moduleType: moduleConstant.Demand,
                Mode: HistoryConfigurations.TYPE_ALL,
                showSendMessage: true,
                showPrint: true,
                showEdit: true,
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
                viewHistory: true,
                selfOpen: false,
            },
            components: {
                // default: DemandDetail
            },
        }
    },

    // new, edit agenda
    {
        types: [ROUTER_HELPER.TYPE.AGENDA],
        actions: [ROUTER_HELPER.ACTION.NEW, ROUTER_HELPER.ACTION.EDIT],
        options: {
            meta: {
                moduleType: moduleConstant.Agenda,
                dialog: true,
                tab: false,
                cache: false,
                icon: ROUTER.AGENDA.AGENDA_ICON,
                showActionView: true,
                showActionNew: true,
                container: true,
                dynamic: true,
            },
            components: {
                // default: AgendaModal
            }
        }
    },

    // view agenda
    // {
    //     types: [ROUTER_HELPER.TYPE.AGENDA],
    //     actions: [ROUTER_HELPER.ACTION.VIEW],
    //     options: {
    //         meta: {
    //             moduleType: moduleConstant.Agenda,
    //             showSendMessage: false,
    //             dialog: true,
    //             tab: false,
    //             cache: false,
    //             icon: ROUTER.AGENDA.AGENDA_ICON,
    //             container: true,
    //             dynamic: true,
    //         },
    //         components: {
    //             default: AgendaDetail
    //         },
    //     }
    // },

    // new, edit task
    {
        types: [ROUTER_HELPER.TYPE.TASK],
        actions: [ROUTER_HELPER.ACTION.NEW, ROUTER_HELPER.ACTION.EDIT],
        options: {
            meta: {
                moduleType: moduleConstant.Task,
                dialog: true,
                tab: false,
                cache: false,
                showSaveAndNew: false,
                showSaveAndClose: true,
                showSave: true,
                showView: false,
                icon: ROUTER.TASK.TASK_ICON,
                container: true,
                dynamic: true,
            },
            components: {
                // default: TaskModal
            }
        }
    },

    // view task
    // {
    //     types: [ROUTER_HELPER.TYPE.TASK],
    //     actions: [ROUTER_HELPER.ACTION.VIEW],
    //     options: {
    //         meta: {
    //             moduleType: moduleConstant.Task,
    //             showSendMessage: false,
    //             dialog: true,
    //             tab: false,
    //             cache: false,
    //             icon: ROUTER.TASK.TASK_ICON,
    //             container: true,
    //             dynamic: true,
    //         },
    //         components: {
    //             default: TaskDetail
    //         },
    //     }
    // },

    // edit property
    {
        types: [ROUTER_HELPER.TYPE.PROPERTY],
        actions: [ROUTER_HELPER.ACTION.EDIT, ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                moduleType: moduleConstant.Object,
                dialog: true,
                tab: false,
                cache: false,
                showSaveAndNew: false,
                showSaveAndClose: true,
                showActionView: true,
                showActionNew: true,
                showSave: true,
                showView: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: PropertyModal
            }
        }
    },

    // clone property
    {
        types: [ROUTER_HELPER.TYPE.CLONE_PROPERTY],
        actions: [ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                moduleType: moduleConstant.Object,
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: PropertyPrepareClone
            },
        }
    },

    // view property
    {
        types: [ROUTER_HELPER.TYPE.PROPERTY],
        actions: [ROUTER_HELPER.ACTION.VIEW],
        options: {
            meta: {
                moduleType: moduleConstant.Object,
                Mode: HistoryConfigurations.TYPE_ALL,
                showSendMail: true,
                showPrint: true,
                showEdit: true,
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
                viewHistory: true,
                showCloneProperty: true,
            },
            components: {
                // default: PropertyDetail
            },
        }
    },

    // edit project
    {
        types: [ROUTER_HELPER.TYPE.PROJECT],
        actions: [ROUTER_HELPER.ACTION.EDIT, ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                moduleType: moduleConstant.Object,
                dialog: true,
                tab: false,
                cache: false,
                showSaveAndNew: false,
                showSaveAndClose: true,
                showActionView: true,
                showActionNew: true,
                showSave: true,
                showView: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: ProjectModal
            }
        }
    },

    // view project
    {
        types: [ROUTER_HELPER.TYPE.PROJECT],
        actions: [ROUTER_HELPER.ACTION.VIEW],
        options: {
            meta: {
                moduleType: moduleConstant.Object,
                Mode: HistoryConfigurations.TYPE_ALL,
                showSendMail: true,
                showPrint: true,
                showEdit: true,
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
                viewHistory: true,
            },
            components: {
                // default: ProjectDetail
            },
        }
    },



    // send message
    {
        types: [ROUTER_HELPER.TYPE.SEND_MESSAGE, ROUTER_HELPER.TYPE.MESSAGE_TO_RELATIONS, ROUTER_HELPER.TYPE.MESSAGE_TO_OWNER],
        actions: [ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
                isPreview: true,
            },
            components: {
                // default: SendMessageViewModal
            },
        }
    },

    // matching demands
    {
        types: [ROUTER_HELPER.TYPE.MATCHING_DEMANDS],
        actions: [ROUTER_HELPER.ACTION.VIEW],
        options: {
            meta: {
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: MatchingDemandsModal
            },
        }
    },

    // PRINT TEMPLATE
    {
        types: [ROUTER_HELPER.TYPE.PRINT_TEMPLATE],
        actions: [ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: PrintTemplateViewModal
            },
        }
    },

    // history wrapper
    {
        types: [ROUTER_HELPER.TYPE.HISTORY],
        actions: [ROUTER_HELPER.ACTION.VIEW, ROUTER_HELPER.ACTION.EDIT, ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: HistoryWrapper
            },
        }
    },

    // clone project
    {
        types: [ROUTER_HELPER.TYPE.CLONE_PROJECT],
        actions: [ROUTER_HELPER.ACTION.NEW],
        options: {
            meta: {
                dialog: true,
                tab: false,
                cache: false,
                container: true,
                dynamic: true,
            },
            components: {
                // default: ProjectPrepareClone
            },
        }
    },
];
